import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './lib/i18n'; // inicializa i18next antes del primer render
import { registerServiceWorker } from './lib/push';
import './index.css';

// PWA (M7): el service worker habilita la instalación y las notificaciones
// push. Solo en producción para no interferir con el dev server de Vite.
if (import.meta.env.PROD) {
  void registerServiceWorker();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('No se encontró el elemento #root');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
